export function debugLogError(message: string, error: any) {
  console.error(message, error);
}
